import React from 'react';
import pt from 'prop-types';

export default class CollectionSort extends React.PureComponent {
  static propTypes = {
    field: pt.oneOfType([pt.object, pt.string]).isRequired,
    label: pt.node.isRequired,
    sorted: pt.bool,
    dir: pt.string,

    onClick: pt.func,
  };

  /** @param {React.MouseEvent} event */
  onClick = (event) => {
    const { field, onClick } = this.props;

    onClick(field, event);
  };

  render() {
    const { label, sorted, dir } = this.props;

    return (
      <button
        data-dir={dir}
        data-sorted={sorted ? 1 : 0}
        className="collection-sort"
        onClick={this.onClick}
        type="button"
      >
        {label}

        {sorted && (
          <span className="collection-sort-icon">
            {dir === 'asc' ? (
              <svg viewBox="0 0 20 20">
                <path d="M15 12l-5-5-5 5z" />
              </svg>
            ) : (
              <svg viewBox="0 0 20 20">
                <path d="M5 8l5 5 5-5z" fillRule="evenodd" />
              </svg>
            )}
          </span>
        )}
      </button>
    );
  }
}

// {field.path ? (
//   <span
//     className="collection-sort"
//     onClick={this.onClickSort.bind(this, field)}
//   >
//     {field.label}
//     {sort &&
//       sortField === String(field.path) && (
//         <span className="collection-sort-icon" onClick={onClick}>
//           {sortDirection === 'asc' ? (
//             <svg viewBox="0 0 20 20">
//               <path d="M15 12l-5-5-5 5z" />
//             </svg>
//           ) : (
//             <svg viewBox="0 0 20 20">
//               <path d="M5 8l5 5 5-5z" fillRule="evenodd" />
//             </svg>
//           )}
//         </span>
//       )}
//   </span>
// ) : (
//   field.label
// )}
